import apiClient from './apiClient';

export const uploadAnimalImages = async (animalId, files) => {
    try {
        const formData = new FormData();
        files.forEach(file => {
            formData.append('files', file);
        });

        const response = await apiClient.post(`/image/upload/?animal_id=${animalId}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const getAnimalImages = async (animalId) => {
    try {
        const response = await apiClient.get(`/image/animal/${animalId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};

export const deleteAnimalImage = async (imageId) => {
    try {
        const response = await apiClient.delete(`/image/${imageId}`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
};